import React, { useState, useEffect } from 'react';
import { ConsoleShell, useConsoleTheme } from '../components/Console';
import { Card, CardTitle } from '../components/UI';
import { supabase } from '../supabaseClient';
const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';
function useIsMobile() {
  const [m,setM]=React.useState(()=>typeof window!=='undefined'&&window.innerWidth<768);
  React.useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  return m;
}
function DataCompletenessBody() {
  const { t } = useConsoleTheme(); // eslint-disable-line no-unused-vars
  const isMobile = useIsMobile();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState({ col:'total', dir:'desc' });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await supabase.rpc('get_data_completeness_by_country');
        if (data) setRows(data);
        else {
          // Fallback: manual aggregation
          const { data: locs } = await supabase.from('Locations')
            .select('country,latitude,phone,website,booking_url,last_verified').limit(5000);
          const map = {};
          (locs||[]).forEach(l => {
            const c = l.country || 'Unknown';
            if (!map[c]) map[c]={country:c,total:0,coords:0,phone:0,website:0,booking:0,verified:0};
            map[c].total++;
            if (l.latitude) map[c].coords++;
            if (l.phone)    map[c].phone++;
            if (l.website)  map[c].website++;
            if (l.booking_url) map[c].booking++;
            if (l.last_verified) map[c].verified++;
          });
          setRows(Object.values(map));
        }
      } catch (_e) {}
      setLoading(false);
    })();
  }, []);

  const sorted = [...rows].sort((a,b) => {
    const av = a[sort.col]??0, bv = b[sort.col]??0;
    return sort.dir==='desc' ? bv-av : av-bv;
  });

  const pct = (n,t) => t>0?Math.round(n/t*100):0;
  const bar = (p) => {
    const c = p>=80?'#28a745':p>=50?'#fd7e14':'#dc3545';
    return <div style={{display:'flex',alignItems:'center',gap:5}}>
      <div style={{width:50,height:5,borderRadius:3,background:'var(--color-background-tertiary)',overflow:'hidden'}}>
        <div style={{height:'100%',width:p+'%',background:c,borderRadius:3}}/>
      </div>
      <span style={{fontSize:'.65rem',color:c,fontWeight:500,minWidth:28}}>{p}%</span>
    </div>;
  };

  const cols = [{k:'country',l:'Country',s:false},{k:'total',l:'Total',s:true},{k:'coords',l:'GPS',s:true},{k:'phone',l:'Phone',s:true},{k:'website',l:'Website',s:true},{k:'booking',l:'Booking URL',s:true},{k:'verified',l:'Verified',s:true}];
  const thS = {fontSize:'.65rem',color:'var(--color-text-secondary)',textTransform:'uppercase',letterSpacing:'.04em',padding:'6px 10px',textAlign:'left',borderBottom:'1px solid var(--color-border-tertiary)',fontWeight:500,whiteSpace:'nowrap',cursor:'pointer'};
  const tdS = {fontSize:'.72rem',padding:'6px 10px',borderBottom:'.5px solid var(--color-border-tertiary)',color:'var(--color-text-primary)'};

  return (
    <div style={{fontFamily:F,padding:isMobile?'16px 14px 80px':'24px 28px'}}>
      <div style={{marginBottom:16}}>
        <h2 style={{fontSize:'1.1rem',fontWeight:500,margin:0,color:'var(--color-text-primary)'}}>Data completeness</h2>
        <p style={{fontSize:'.78rem',color:'var(--color-text-secondary)',margin:'4px 0 0'}}>Per-country breakdown of field coverage. Click column headers to sort.</p>
      </div>
      <Card>
        {loading ? <div style={{padding:'20px',color:'var(--color-text-secondary)',fontSize:'.78rem'}}>Loading…</div> : (
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',minWidth:600}}>
              <thead>
                <tr>{cols.map(c=>(
                  <th key={c.k} style={{...thS,color:sort.col===c.k?'#314F5C':undefined}} onClick={()=>c.s&&setSort(s=>({col:c.k,dir:s.col===c.k&&s.dir==='desc'?'asc':'desc'}))}>
                    {c.l} {c.s&&(sort.col===c.k?(sort.dir==='desc'?'↓':'↑'):'↕')}
                  </th>
                ))}</tr>
              </thead>
              <tbody>{sorted.slice(0,50).map(r=>(
                <tr key={r.country}>
                  <td style={{...tdS,fontWeight:500}}>{r.country}</td>
                  <td style={tdS}>{(r.total||0).toLocaleString()}</td>
                  <td style={tdS}>{bar(pct(r.coords,r.total))}</td>
                  <td style={tdS}>{bar(pct(r.phone,r.total))}</td>
                  <td style={tdS}>{bar(pct(r.website,r.total))}</td>
                  <td style={tdS}>{bar(pct(r.booking,r.total))}</td>
                  <td style={tdS}>{bar(pct(r.verified,r.total))}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}

export default function DataCompleteness(props) {
  if (props && props.embed) return <DataCompletenessBody {...props} />;
  return <ConsoleShell title="Data Completeness"><DataCompletenessBody {...props} /></ConsoleShell>;
}
